import React from "react";
import WaveText from "../WaveText";

export default function OpenQuestionsGeneratorPanel({
  showOpenQuestionsGenerator, generatedOpenQuestions, showAskMe, showTemplates,
  showABCDGenerator, showWordDefinitionGenerator, showWordTranslationGenerator,
  showTrueFalseGenerator, showWarmUpDiscussionGenerator, showCreateDialogueGenerator,
  showEssentialVocabularyGenerator, showLeadInActivitiesGenerator, showFourOpinionsGenerator,
  showCommunicativeSituationsGenerator, showMatchingHalvesGenerator, showErrorCorrectionGenerator,
  showGrammarRulesGenerator, showJumbledSentenceGenerator, showMultipleChoiceGenerator,
  openQuestionsInput, setOpenQuestionsInput, openQuestionsLevel, setOpenQuestionsLevel,
  openQuestionsCount, setOpenQuestionsCount, openQuestionsLoading,
  handleOpenQuestionsGenerate, handleOpenQuestionsInsert, handleOpenQuestionsCancel,
}) {
  if (!((showOpenQuestionsGenerator || generatedOpenQuestions) && !showAskMe && !showTemplates && !showABCDGenerator && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator && !showJumbledSentenceGenerator && !showMultipleChoiceGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleOpenQuestionsCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Open Questions</span>
      </div>

      <textarea
        value={openQuestionsInput}
        onChange={e => setOpenQuestionsInput(e.target.value)}
        placeholder="Paste your text here, based on which we'll generate open questions"
        rows={4}
        style={{ fontSize: 15, padding: '12px', borderRadius: 8, border: '1.5px solid #cfcfff', background: '#f7fbff', resize: 'vertical', fontFamily: 'Inter, Segoe UI, Arial, sans-serif', width: '100%', boxSizing: 'border-box' }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          CEFR Level:
          <select value={openQuestionsLevel} onChange={e => setOpenQuestionsLevel(e.target.value)} style={{ fontSize: 14, padding: '6px 8px', borderRadius: 6, border: '1.5px solid #cfcfff', background: '#fff', cursor: 'pointer' }}>
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          Questions:
          <input type="number" min={1} max={10} value={openQuestionsCount} onChange={e => setOpenQuestionsCount(e.target.value)} onBlur={e => setOpenQuestionsCount(Math.max(1, Math.min(10, Number(e.target.value) || 1)))} title="1–10 questions" style={{ fontSize: 14, padding: '6px 8px', borderRadius: 6, border: '1.5px solid #cfcfff', background: '#fff', width: 80 }} />
          <span style={{ fontSize: 12, color: '#8f8fb0', fontWeight: 400, whiteSpace: 'nowrap' }}>max 10</span>
        </label>
      </div>

      <button
        onClick={handleOpenQuestionsGenerate}
        disabled={openQuestionsLoading || !openQuestionsInput.trim()}
        className={openQuestionsLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{ fontSize: 15, padding: '12px 16px', borderRadius: 8, border: 'none', background: openQuestionsLoading || !openQuestionsInput.trim() ? '#e0e0e0' : '#8a2be2', color: openQuestionsLoading || !openQuestionsInput.trim() ? '#999' : '#fff', fontWeight: 600, cursor: openQuestionsLoading || !openQuestionsInput.trim() ? 'not-allowed' : 'pointer', transition: 'all 0.2s' }}
      >
        {openQuestionsLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedOpenQuestions && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>Generated: Open Questions Exercise</div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>{generatedOpenQuestions.questions?.length || 0} questions ready</div>
          <button onClick={handleOpenQuestionsInsert} className="magic-btn" style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}>Add</button>
        </div>
      )}
    </div>
  );
}
